// extracted by mini-css-extract-plugin
export default {"root":"Xxk6i_","hidden":"zUzA3a","info":"joJJJi","block":"w7aJVT","name":"czP5IJ","description":"x30lh4","prepayment":"dYNda9","editButton":"udYy8P"};